/* eslint-disable */
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { max } from "date-fns";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const IndirectTaxBarChart = ({ data }) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);

  const chartData = {
    labels: data.map((item) => item.label),
    datasets: [
      {
        label: "Penalties",
        data: data.map((item) => item.value),
        backgroundColor: "#2f78c4",
        borderRadius: 2,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        right: 25,   // <-- adds space below legend
      },
    },
    plugins: {
      legend: { display: false },
      datalabels: {
        anchor: 'end',
        align: 'end',      
        color: 'black',          
        font: {
          size: 10,
          weight: 'bold',
        },
        formatter: (value) => value,
      },
    },
    
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
          autoSkip: false,
          font: {
            size: 8,
          },
        },
        title: {
          display: false,
        },
      },
      x: {
        type: 'linear',
        position: 'bottom',
        min: 5,
        ticks: {
          font: {
            size: 10,
          },
          stepSize: 10,
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", maxWidth: "100%", height: "300px" }}>
      <Bar data={chartData} options={options}/>
    </div>
  );
};

export default IndirectTaxBarChart;
